<template>
  <div class="d-flex align-items-center gap-1">
    <i
      v-b-tooltip.hover
      class="icon-outline_license-general"
      :class="rfidIconClass"
      :title="rfidTooltip"
      style="font-size: 1.2rem"
    />

    <i
      v-b-tooltip.hover
      class="icon-outline_fr-default"
      :class="faceIconClass"
      :title="faceTooltip"
      style="font-size: 1.2rem"
    />

    <span class="text-muted mx-1">|</span>

    <span
      v-b-tooltip.hover
      :class="driverLimitClass"
      :title="$t('rfidAndFacerecognition.driverLimit')"
      style="font-size: 0.85rem"
    >
      {{ driverLimitLabel }}
    </span>
  </div>
</template>

<script>
import { VBTooltip } from 'bootstrap-vue'
import { FACE_RECOGNITION_STATUS, RFID_STATUS } from '@/helpers/face-recognition'
const SUPPORTED = 'Supported'
const DRIVER_MAX = 30

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },

  props: {
    option: {
      type: Object,
      required: true,
    },
  },

  computed: {
    identificationSupport() {
      return this.option.identificationSupport ?? {}
    },

    hasRFIDSupport() {
      return this.identificationSupport.rfid === SUPPORTED
    },

    hasFaceRecognitionSupport() {
      return this.identificationSupport.face === SUPPORTED
    },

    configuredCount() {
      const identification = this.option.identification
      if (!identification || identification.length === 0) return 0

      return identification.filter((item) => {
          const face = item?.face?.status
          const rfid = item?.rfid?.status
          if (face === null && rfid === null) return false

          const faceValid = face === FACE_RECOGNITION_STATUS.VALID || face === null
          const rfidValid = rfid === RFID_STATUS.SUCCESS || rfid === null
          return faceValid && rfidValid 
      }).length
    },


    rfidIconClass() {
      return this.hasRFIDSupport ? 'text-success' : 'text-muted'
    },

    rfidTooltip() {
      const key = this.hasRFIDSupport
        ? 'rfidAndFacerecognition.supported'
        : 'rfidAndFacerecognition.notSupported'
      return this.$t(key)
    },

    faceIconClass() {
      return this.hasFaceRecognitionSupport ? 'text-success' : 'text-muted'
    },

    faceTooltip() {
      const key = this.hasFaceRecognitionSupport
        ? 'rfidAndFacerecognition.cameraSupported'
        : 'rfidAndFacerecognition.cameraNotSupported'
      return this.$t(key)
    },

    driverLimitClass() {
      return this.configuredCount > 0 ? 'text-success' : 'text-muted'
    },

    driverLimitLabel() {
      return `(${this.configuredCount}/${DRIVER_MAX})`
    },
  },
}
</script>
